export enum CasePhoneContactInformationType {
    UNKNOWN = 1,
    PHONE = 2,
    MOBILE = 3,
}
